/**
 * Referral welcome popup UI flags (per-browser, not user-scoped).
 * Cleared on logout via clearReferralWelcomeStorageOnLogout.
 */

export const REFERRAL_WELCOME_SHOWN_KEY = "illumi-referral-welcome-shown";

export const REFERRAL_CHECKOUT_TIMESTAMP_KEY =
	"illumi-referral-checkout-timestamp";

export const REFERRAL_CHECKOUT_COOLDOWN_MS = 10000;

export function getReferralWelcomeShown(): boolean {
	try {
		return localStorage.getItem(REFERRAL_WELCOME_SHOWN_KEY) === "true";
	} catch {
		return false;
	}
}

export function setReferralWelcomeShown(): void {
	try {
		localStorage.setItem(REFERRAL_WELCOME_SHOWN_KEY, "true");
	} catch {
		// localStorage may be unavailable
	}
}

export function getReferralCheckoutTimestampMs(): number | null {
	try {
		const v = localStorage.getItem(REFERRAL_CHECKOUT_TIMESTAMP_KEY);
		if (!v) return null;
		const n = Number.parseInt(v, 10);
		return Number.isNaN(n) ? null : n;
	} catch {
		return null;
	}
}

export function setReferralCheckoutTimestampNow(): void {
	try {
		localStorage.setItem(
			REFERRAL_CHECKOUT_TIMESTAMP_KEY,
			Date.now().toString(),
		);
	} catch {
		// localStorage may be unavailable
	}
}

export function clearReferralCheckoutTimestamp(): void {
	try {
		localStorage.removeItem(REFERRAL_CHECKOUT_TIMESTAMP_KEY);
	} catch {
		// localStorage may be unavailable
	}
}

export function isWithinReferralCheckoutCooldown(): boolean {
	const ts = getReferralCheckoutTimestampMs();
	if (ts === null) return false;
	return Date.now() - ts < REFERRAL_CHECKOUT_COOLDOWN_MS;
}

/** Removes checkout timestamp after cooldown so the popup can show again. */
export function removeStaleReferralCheckoutTimestampIfCooldownPassed(): void {
	const ts = getReferralCheckoutTimestampMs();
	if (ts === null) return;
	if (Date.now() - ts >= REFERRAL_CHECKOUT_COOLDOWN_MS) {
		clearReferralCheckoutTimestamp();
	}
}

/**
 * If checkout closed without a timestamp, set one so the welcome modal stays
 * suppressed briefly (same as after "need payment method").
 */
export function ensureReferralCheckoutCooldownTimestampIfAbsent(): void {
	try {
		if (localStorage.getItem(REFERRAL_CHECKOUT_TIMESTAMP_KEY) === null) {
			setReferralCheckoutTimestampNow();
		}
	} catch {
		// localStorage may be unavailable
	}
}

export function clearReferralWelcomeStorageOnLogout(): void {
	try {
		localStorage.removeItem(REFERRAL_WELCOME_SHOWN_KEY);
		localStorage.removeItem(REFERRAL_CHECKOUT_TIMESTAMP_KEY);
	} catch {
		// localStorage may be unavailable
	}
}
